import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { usePowtoonAuth } from "@/lib/auth/PowtoonAuthContext";
import { trackEvent } from "@/services/analytics";
import { ANALYTICS_CATEGORIES, ANALYTICS_ACTIONS } from "@/config/analytics-config";

export function UserMenu() {
  const { user, signOut } = usePowtoonAuth();
  const navigate = useNavigate();
  if (!user) return null;
  const display = user.displayName ?? user.email;
  const initials = (display || "U")
    .split(/\s+/).map((s) => s[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-10 w-10 rounded-full p-0" title="Account">
          <Avatar className="h-10 w-10">
            {user.avatarUrl ? <img src={user.avatarUrl} alt={display} className="h-full w-full object-cover" /> : null}
            <AvatarFallback className="bg-primary text-primary-foreground">{initials}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <div className="px-2 py-1.5">
          <div className="text-sm font-medium leading-none">{display}</div>
          <div className="mt-1 truncate text-xs text-muted-foreground">{user.email}</div>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => {
          trackEvent({
            category: ANALYTICS_CATEGORIES.NAVIGATION,
            action: ANALYTICS_ACTIONS.CLICK,
            ga4EventName: "navigation_click",
            label: "user_menu_sign_out",
          });
          signOut();
          navigate("/");
        }}>
          <LogOut className="h-4 w-4" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
